<template>
    <Page :header="content[lang_].name">
        <template #body>
            <div class="flex flex-column w-full">
                <p>
                    {{content[lang_].text}}
                </p>
                <div>
                    <Button :label="content[lang_].button" @click="go_main" />
                </div>
            </div>
        </template>
    </Page>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { useRoute } from 'vue-router'
import Page from '@/components/sides/Page.vue'

export default {
    name: 'PaypalSuccess',
    data() {
        return {
            content:{
                en: {
                    name: 'Successfully subscribed to notifications',
                    text: 'Now you will be able to receive notifications about the status of the translation by mail',
                    button: 'Main page'
                },
                ru: {
                    name: 'Успешная подиска на уведомления',
                    text: 'Теперь можно сможете получать уведомления о статусе перевода на почту',
                    button: 'На главную'
                }
            },
            id: null,
        }
    },
    components: {
        Page
    },
    computed: {
        lang_() {
            return (this.$i18n.locale) ? this.$i18n.locale : 'en'
        }
    },
    watch: {
        
    },
    methods: {
        go_main(){
            this.$router.push({
                path: '/'
            })
        },
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
        const route = useRoute()

        if(route.query.id!='') this.id = route.query.id

        if(this.id && this.id.length==24){
            let res = await this.connect.transfer_check_payment(this.id)
        }
    },
}
</script>